import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Phone, ChevronDown } from 'lucide-react';
import { footerGroups } from '../data/navigation';
import { siteConfig } from '../data/siteConfig';

export function Footer() {
  const [openGroup, setOpenGroup] = useState<string | null>(null);

  return (
    <footer className="site-footer-landscape overflow-hidden">
      <div className="site-footer-body">
        <div className="mx-auto w-full max-w-[1540px] px-4 pb-9 pt-0 sm:px-6 lg:px-8">
          <div className="grid gap-8 lg:grid-cols-[1.15fr_.7fr_.7fr_.82fr_.82fr] lg:gap-10 xl:gap-16">
            <div className="mb-4 lg:mb-0">
              <Link to="/" className="inline-flex items-center gap-4 rounded-2xl bg-white px-4 py-3 shadow-soft ring-1 ring-white/60">
                <img src="/zfast-logo.webp" alt="ZFAST Agritech India" width={150} height={48} className="h-12 w-auto object-contain shrink-0" />
                <span>
                  <span className="block text-lg font-black leading-tight text-ink">{siteConfig.name}</span>
                  <span className="block text-[0.7rem] font-black uppercase tracking-[0.18em] text-forest/70">Nutrition & Agritech Supply</span>
                </span>
              </Link>
              <div className="mt-5 grid gap-3 text-sm font-semibold text-white/90">
                <a className="flex items-center gap-3 hover:text-[#CFE8B7]" href={siteConfig.phoneHref}>
                  <Phone className="h-4 w-4 shrink-0 text-[#CFE8B7]" />
                  {siteConfig.phone}
                </a>
                <a className="flex items-center gap-3 break-all hover:text-[#CFE8B7]" href={`mailto:${siteConfig.email}`}>
                  <Mail className="h-4 w-4 shrink-0 text-[#CFE8B7]" />
                  {siteConfig.email}
                </a>
                <address className="flex items-start gap-3 not-italic">
                  <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#CFE8B7]" aria-hidden="true" />
                  {siteConfig.address}
                </address>
              </div>
            </div>

            {footerGroups.map((group) => (
              <div key={group.title} className="border-b border-white/10 pb-4 lg:border-0 lg:pb-0">
                <button 
                  onClick={() => setOpenGroup(openGroup === group.title ? null : group.title)}
                  className="flex w-full items-center justify-between text-sm font-black uppercase tracking-[0.22em] text-[#DDEFCB] lg:cursor-default lg:pointer-events-none"
                >
                  {group.title}
                  <ChevronDown className={`h-5 w-5 transition-transform duration-300 lg:hidden ${openGroup === group.title ? 'rotate-180' : ''}`} />
                </button>
                <div className={`mt-5 grid gap-3 text-sm font-semibold text-white/86 overflow-hidden transition-all duration-300 ${openGroup === group.title ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'} lg:!max-h-96 lg:!opacity-100 lg:!grid`}>
                  {group.links.map((link) => (
                    <Link key={link.href} className="inline-flex items-center gap-3 hover:text-[#CFE8B7]" to={link.href}>
                      <span className="text-[#DDEFCB]">→</span>
                      {link.label}
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-10 border-t border-white/20 pt-6 text-center text-xs text-white/72">
            © 2026 {siteConfig.legalName}. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}
